<template>
  <div v-if="data">
    <country-details :data-country.sync="data" @update:dataCountry="updateCountry" />
    <transaction-fees
      class="mt-3"
      :fees_url="`/api/v1/transactions/transferReceivingCountry/${data.id}/fees`"
    />
  </div>
</template>

<script>
import TransactionFees from "../fees";
import CountryDetails from "./details";

export default {
  props: {
    id: {
      required: true,
    },
  },
  components: {
    TransactionFees,
    CountryDetails,
  },
  data: () => ({
    data: null,
  }),
  mounted() {
    this.fetchCountry();
  },
  watch: {
    id() {
      this.fetchCountry();
    },
  },
  methods: {
    fetchCountry() {
      this.$http
        .get(`/api/v1/transactions/transferReceivingCountries/${this.id}`)
        .then((data) => (this.data = data));
    },
    updateCountry(country) {
      if (country) {
        this.country = country;
      }
    },
  },
};
</script>

<style></style>
